import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslateMatPaginatorIntl extends MatPaginatorIntl {
  private readonly translationsParentKey = 'Domiciliation';
  private rangeLabel: string | null = null;

  constructor(private readonly translateService: TranslateService) {
    super();

    this.translateService.onLangChange.subscribe(() => {
      this.translate();
    });

    this.translate();

    this.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 ${this.rangeLabel} ${length}`;
      }

      length = Math.max(length, 0);

      const startIndex = page * pageSize;

      // If the start index exceeds the list length, do not try and fix the end index to the end.
      const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;

      return `${startIndex + 1} - ${endIndex} ${this.rangeLabel} ${length}`;
    };
  }

  translate() {
    this.translateService.get(this.translationsParentKey)
      .subscribe(translations => {
        this.itemsPerPageLabel = translations['Paginator-ItemsPerPage'];
        this.nextPageLabel = translations['Paginator-NextPage'];
        this.previousPageLabel = translations['Paginator-PreviousPage'];
        this.firstPageLabel = translations['Paginator-FirstPage'];
        this.lastPageLabel = translations['Paginator-LastPage'];
        this.rangeLabel = translations['Paginator-Range'];
        this.changes.next();
      });
  }
}
